import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XCircleIcon, ChevronDownIcon } from 'lucide-react';
const painPoints = [{
  title: 'Llegás a la mesa sin saber qué hacer',
  desc: 'Sin saber qué rutina o drill específico vas a trabajar hoy. Solo "peloteo".'
}, {
  title: 'Tu Topspin no progresa',
  desc: 'Sin estructura clara para transferir el peso y generar velocidad y efecto reales.'
}, {
  title: 'Pierdes puntos por "tonterías"',
  desc: 'Molestias técnicas o errores no forzados que no sabes cómo prevenir.'
}, {
  title: 'Siempre el mismo esquema',
  desc: 'No sabes cómo transicionar entre la defensa, el bloqueo y el contraataque.'
}, {
  title: 'Partidos ajustados inalcanzables',
  desc: 'Llegas al 9-9 y el pánico te hace fallar. Te falta un sistema de decisiones estructurado.'
}, {
  title: 'Tips sueltos de Instagram/YouTube',
  desc: 'Sin un método claro que respalde tu biomecánica.'
}, {
  title: 'Gomas y maderas al azar',
  desc: 'Gastas fortunas en equipo sin saber si realmente se adapta a tu estilo.'
}, {
  title: 'Fin de mes sin progreso',
  desc: 'Sin métricas ni sobrecarga de dificultad, no avanzás.'
}];
export function PainPointsSection() {
  const [expanded, setExpanded] = useState<number[]>([]);
  const toggleExpand = (index: number) => {
    setExpanded(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
  };
  return <section className="py-10 sm:py-16 lg:py-24 bg-navy-900" data-id="element-192">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 sm:mb-12 lg:mb-16" data-id="element-194">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display text-offwhite uppercase mb-3" data-id="element-195">
            ¿TE PASA <span className="text-red-500" data-id="element-196">ESTO?</span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-text-secondary max-w-2xl mx-auto" data-id="element-197">
            Si juegas al tenis de mesa en Argentina y quieres competir, esto te
            suena familiar:
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-2 gap-3 sm:gap-5 md:gap-8" data-id="element-198">
          {painPoints.map((pain, i) => {
          const isExpanded = expanded.includes(i);
          return <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.05
          }} onClick={() => toggleExpand(i)} className="flex flex-col p-3 sm:p-4 rounded-lg bg-navy-800/30 hover:bg-navy-800/60 border border-navy-800 transition-colors cursor-pointer md:cursor-default" data-id="element-199">
                <div className="flex gap-2.5 sm:gap-4 items-start" data-id="element-200">
                  <div className="flex-shrink-0 mt-0.5 sm:mt-1" data-id="element-201">
                    <XCircleIcon className="w-4 h-4 sm:w-5 sm:h-5 text-red-500" data-id="element-202" />
                  </div>
                  <div className="flex-grow" data-id="element-203">
                    <div className="flex justify-between items-start" data-id="element-204">
                      <h3 className="font-bold text-offwhite text-xs sm:text-sm md:text-base mb-0.5 leading-tight pr-2" data-id="element-205">
                        {pain.title}
                      </h3>
                      <ChevronDownIcon className={`w-4 h-4 text-text-secondary md:hidden flex-shrink-0 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} data-id="element-206" />
                    </div>

                    {/* Desktop always visible description */}
                    <p className="hidden md:block text-text-secondary text-sm leading-relaxed mt-1" data-id="element-207">
                      {pain.desc}
                    </p>
                  </div>
                </div>

                {/* Mobile expandable description */}
                <AnimatePresence data-id="element-208">
                  {isExpanded && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="md:hidden overflow-hidden" data-id="element-209">
                      <p className="text-text-secondary text-[11px] sm:text-xs leading-snug mt-2 pl-6 sm:pl-9" data-id="element-210">
                        {pain.desc}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-8 sm:mt-12 text-center" data-id="element-211">
          <p className="text-xl sm:text-2xl md:text-3xl font-display text-gold-400 uppercase tracking-wide" data-id="element-212">
            ¿Cuántos meses más vas a jugar improvisando?
          </p>
        </motion.div>
      </div>
    </section>;
}